import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCompassPointer"><Path d="M10.1862 2.94395C10.9037 1.4028 13.0956 1.4028 13.8131 2.94395L20.8766 18.1158C21.6774 19.8363 19.8557 21.6011 18.1617 20.7457L12.4508 17.8609C12.1673 17.7178 11.8319 17.7178 11.5485 17.8609L5.83753 20.7457C4.14374 21.6006 2.32224 19.8361 3.12268 18.1158L10.1862 2.94395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCompassPointer;
